module.exports = __webpack_public_path__ + "img/pro_bannerbg.85cf784c.jpg";